import React, { Component, Fragment } from 'react'
import { NavLink } from "react-router-dom";
import { IsAuthorize } from '../../../../shared/authorization/check-access';
import { Role } from '../../../../shared/authorization/enums';


interface IProps {
    id: number,
    url: string
}
export  class EmailTemplatesTabs extends Component<IProps> {
    render() {
        return (
            <Fragment>
            <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item">
                {IsAuthorize([Role.TAM, Role.Dev, Role.Support, Role.AM, Role.Admin, Role.SuperAdmin]) && <NavLink to={"/email-template/email-template-form/" + this.props.id} className={this.props.url=="/email-template/email-template-form/"?"nav-link active":"nav-link"} id="show-tab" data-toggle="tab" href="#edit" role="tab"
                    aria-controls="edit" aria-selected={this.props.url=="/email-template/email-template-form/"?"true":"false"}><i className="far fa-edit"></i>&nbsp;Edit</NavLink>}
            </li>
             <li className="nav-item">
                {IsAuthorize([Role.TAM, Role.Dev, Role.Support, Role.Admin, Role.SuperAdmin]) && <NavLink to={"/email-template/delete/" + this.props.id} className={this.props.url == "/email-template/delete/" ? "nav-link active" : "nav-link"} id="show-tab" data-toggle="tab" href="#delete" role="tab"
                        aria-controls="delete" aria-selected={this.props.url == "/email-template/delete/" ? "true" : "false"}><i className="far fa-trash-alt"></i>&nbsp;Delete</NavLink>}
                </li>
                <li className="nav-item">
                    <NavLink to={"/email-template/detail/" + this.props.id} className={this.props.url == "/email-template/detail/" ? "nav-link active" : "nav-link"} id="detail-tab" data-toggle="tab" href="#edit" role="tab"
                        aria-controls="detail" aria-selected={this.props.url == "/email-template/detail/" ? "true" : "false"}><i className="fas fa-info-circle"></i>&nbsp;Show</NavLink>
                </li>
            </ul>
            <br />
        </Fragment>
        )
    }
}
